import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  groupIcon,
  groupPositionLabel,
  groupReadyLabel,
  LinkSummary,
  notifyPreferenceLabel,
} from '@classes/linked-patients';
import { LinkedJobsDialogComponent } from '../linked-jobs-dialog.component';
import { PatientService } from '@services/patient.service';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'app-linked-job-badge',
  templateUrl: './linked-job-badge.component.html',
  styleUrls: ['./linked-job-badge.component.css'],
})
export class LinkedJobBadgeComponent {
  @Input() summary: LinkSummary;
  @Input() patientId: string;

  constructor(
    private dialog: MatDialog,
    private patientService: PatientService,
    private notification: NotificationService
  ) {}

  get showPatientJobs(): boolean {
    return (this.summary?.patientJobCount || 0) > 1;
  }

  get showGroupJobs(): boolean {
    return !!(this.summary?.groupKind && (this.summary?.groupJobCount || 0) > 1);
  }

  get showNotify(): boolean {
    return this.showPatientJobs || this.showGroupJobs;
  }

  groupIconName(): string {
    return groupIcon(this.summary?.groupKind);
  }

  patientPosition(): string {
    return `PATIENT JOB ${this.summary?.patientJobIndex || 1} OF ${this.summary?.patientJobCount || 1}`;
  }

  patientReady(): string {
    return `PATIENT JOBS · ${this.summary?.patientReadyCount || 0} OF ${this.summary?.patientJobCount || 0} READY`;
  }

  groupPosition(): string {
    return groupPositionLabel(
      String(this.summary?.groupKind || 'LINKED'),
      this.summary?.groupJobIndex || 1,
      this.summary?.groupJobCount || 1
    );
  }

  groupReady(): string {
    return groupReadyLabel(
      String(this.summary?.groupKind || 'LINKED'),
      this.summary?.groupReadyCount || 0,
      this.summary?.groupJobCount || 0
    );
  }

  notifyLabel(): string {
    return notifyPreferenceLabel(this.summary?.notifyPreference);
  }

  openSummary(): void {
    const jobs = this.summary?.jobs || [];
    if (!jobs.length) {
      return;
    }
    this.dialog
      .open(LinkedJobsDialogComponent, {
        width: '520px',
        data: {
          jobs,
          notifyPreference: this.summary?.notifyPreference,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (!result?.preference || !this.patientId) {
          return;
        }
        this.patientService.saveNotifyPreference(this.patientId, result.preference).subscribe({
          next: (res) => {
            if (this.summary) {
              this.summary.notifyPreference = res?.notifyPreference || result.preference;
            }
            this.notification.show('success', 'Notification preference saved');
          },
          error: (err) => {
            this.notification.show(
              'error',
              err?.error?.message || 'Could not save the notification preference'
            );
          },
        });
      });
  }
}
